<script setup lang='ts'>
import { useCommentInputComponent } from '../hooks/comment'

const props = withDefaults(defineProps<{
  show?: boolean // 是否显示
  autoFocus?: boolean // 是否自动获取焦点
  articleId?: string | null
  commentId?: string | null // 评论文章（null） | 评论评论（number）
  commentName?: string // 评论谁
  option?: { parentIndex?: number; index?: number; isChild?: boolean; toMediaAvatar?: string; toMediaName?: string; toMediaUserId?: string; toCommentId?: string }
}>(), {
  show: false,
  autoFocus: false,
  articleId: null,
  commentId: null,
  commentName: '',
})
const emits = defineEmits({
  'update:show': (show: boolean) => typeof show === 'boolean',
  'commentBefore': (content: string) => typeof content === 'string',
  'commentAfter': (data: any) => !!data,
})
function updateShowHandle(show: boolean) {
  emits('update:show', show)
}
const {
  inputRef,
  isLoading,
  commentContent,
  debounceCommentHandle,

  focusHandle,
  blurHandle,
  changeHandle,
} = useCommentInputComponent(props, emits)

const watchHandler = () => {
  if (props.show)
    inputRef.value?.focus()
}
let stop = watchEffect(watchHandler)
onActivated(() => {
  stop?.()
  stop = watchEffect(watchHandler)
})
onUnmounted(() => stop?.())
onDeactivated(() => stop?.())
</script>

<template>
  <div>
    <van-popup
      :show="show"
      safe-area-inset-bottom
      round
      position="bottom"
      :style="{ height: 'auto' }"
      @update:show="updateShowHandle"
    >
      <div h-full flex="~ col" bg-gray-100>
        <div class=" p-4 text-4 flex justify-between bg-white">
          <span @click="updateShowHandle(false)">取消</span>
          <span text-primary @click="debounceCommentHandle(props.articleId || '', props.commentId || '')">评论</span>
        </div>
        <div px-4 pt-0 pb-8 bg-white>
          <n-input
            ref="inputRef"
            v-model:value="commentContent"
            class="bg-gray-100 rounded-md overflow-hidden"
            maxlength="500"
            :autosize="{ minRows: 5 }"
            autofocus
            show-count type="textarea"
            placeholder="说点什么..."
            @focus="focusHandle"
            @blur="blurHandle"
            @change="changeHandle"
          />
        </div>
      </div>
    </van-popup>
  </div>
</template>
